/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


export { academy_courseStatus_completed } from "./en-US.js"

export { academy_courseStatus_inProgress_endingText } from "./en-US.js"

export { academy_courseStatus_inProgress_startingText } from "./en-US.js"

export { academy_courseStatus_registered } from "./en-US.js"

export { academy_courseStatus_viewed } from "./en-US.js"

export { academy_globalHead_bestPractices } from "./en-US.js"

export { academy_globalHead_collection } from "./en-US.js"

export { academy_globalHead_course } from "./en-US.js"

export { academy_globalHead_lesson } from "./en-US.js"

export { academy_globalHead_metaDesc } from "./en-US.js"

export { academy_globalHead_opengraphSiteName } from "./en-US.js"

export { academy_globalHead_search } from "./en-US.js"

export { academy_globalHead_title } from "./en-US.js"

export { academy_pages_404_button_href } from "./en-US.js"

export { academy_pages_404_button_label } from "./en-US.js"

export { academy_pages_404_titleText } from "./en-US.js"

export { academy_pages_home_hero_button_href } from "./en-US.js"

export { academy_pages_home_hero_button_label } from "./en-US.js"

export { academy_pages_home_hero_headline } from "./en-US.js"

export { academy_pages_home_hero_subhead } from "./en-US.js"

export { academy_pages_home_learn_headline } from "./en-US.js"

export { academy_pages_home_learn_row1_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row1_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row1_content } from "./en-US.js"

export { academy_pages_home_learn_row1_title } from "./en-US.js"

export { academy_pages_home_learn_row2_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row2_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row2_content } from "./en-US.js"

export { academy_pages_home_learn_row2_title } from "./en-US.js"

export { academy_pages_home_learn_row3_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row3_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row3_content } from "./en-US.js"

export { academy_pages_home_learn_row3_title } from "./en-US.js"

export { academy_pages_home_learn_row4_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row4_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row4_content } from "./en-US.js"

export { academy_pages_home_learn_row4_title } from "./en-US.js"

export { academy_pages_home_learn_row5_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row5_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row5_content } from "./en-US.js"

export { academy_pages_home_learn_row5_title } from "./en-US.js"

export { academy_pages_home_learn_row6_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row6_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row6_content } from "./en-US.js"

export { academy_pages_home_learn_row6_title } from "./en-US.js"

export { academy_pages_home_learn_subhead } from "./en-US.js"

export { academy_pages_home_liveTraining_button_href } from "./en-US.js"

export { academy_pages_home_liveTraining_button_label } from "./en-US.js"

export { academy_pages_home_liveTraining_subhead } from "./en-US.js"

export { academy_pages_home_liveTraining_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_headline } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_subhead } from "./en-US.js"

export { academy_pages_home_start_loggedIn_button_href } from "./en-US.js"

export { academy_pages_home_start_loggedIn_button_label } from "./en-US.js"

export { academy_pages_home_start_loggedIn_collectionPath } from "./en-US.js"

export { academy_pages_home_start_loggedIn_coursePath } from "./en-US.js"

export { academy_pages_home_start_loggedIn_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_button_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_button_label } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_title } from "./en-US.js"

export { academy_pages_home_testimonials_headline } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_text } from "./en-US.js"

export { alertBar_dismiss } from "./en-US.js"

export { atoms_singleLineForm_error } from "./en-US.js"

export { atoms_singleLineForm_placeholderText } from "./en-US.js"

export { atoms_singleLineForm_primaryButton } from "./en-US.js"

export { atoms_skipButton_skipContent } from "./en-US.js"

export { atoms_slideIndicator_currentSlide } from "./en-US.js"

export { atoms_slideIndicator_goToSlide } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `Inicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `Buscar todo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `Mapa del sitio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `Nota`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `Requisitos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `Advertencia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `Recursos destacados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/en-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `Solicitud de acceso a la cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `Artículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `Categoría`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Busca en nuestra base de conocimientos para encontrar las respuestas a las preguntas más frecuentes. Explora nuestros artículos, el foro de la comunidad y las capacitaciones grabadas y en vivo, entre otros recursos, para aprender a usar Klaviyo y conocer nuestras mejores prácticas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Centro de ayuda de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `Sección`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Centro de ayuda de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Descubre más sobre Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `¿En qué podemos ayudarte hoy?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `Ir al centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `No se encontró | Centro de ayuda de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `Artículos principales`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `Recursos destacados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Descubre guías educativas, cursos y materiales para que tu negocio crezca con Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `Buscar por tema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `Buscar por tema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `No hay resultados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `Prueba con otra búsqueda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `No hay resultados para`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `Comunidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `Desarrolladores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `Recursos de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `Ver todos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCode_languageString = () => `Spanish (Mexico)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `es-MX`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `es-mx`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `mx`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `es`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `America/Mexico_City`


export { molecule_unifiedSearchResultGridItem_nextEventDetails_upcomingDates } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `Aprox.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `min. de lectura`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `Actualizado el`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `Más información sobre cómo contactar al equipo de asistencia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Permitir que Klaviyo se comunique conmigo con respecto a mis comentarios.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `Describe lo que quieres hacer, aprender o resolver.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `Asegúrate de que tu dirección de correo electrónico tenga una sola @, seguida de un dominio válido (nombre@ejemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `¿Cómo podemos mejorar este artículo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `Describe lo que te gustó o cómo se podría mejorar el artículo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `Hacen falta más detalles o explicaciones.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `No está relacionado con mi búsqueda.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `Gracias por informarnos. Cuéntanos más sobre el problema.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `¿Podrías darnos más detalles?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `Enviar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `Solo nos pondremos en contacto contigo en relación con tus comentarios sobre este artículo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `Correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `nombre@ejemplo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `Es poco claro, confuso o difícil de entender.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `No coincide con la experiencia del producto.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `Usa este formulario solo para enviar comentarios sobre el artículo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `¿Te resultó útil este artículo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `No`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `Se enviaron tus comentarios. Gracias.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `Nos alegra que te haya servido.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `Sí`


export { molecules_blogAuthor_authorAltText } from "./en-US.js"

export { molecules_blogAuthor_defaultAuthorAltText } from "./en-US.js"

export { molecules_blogAuthor_minRead } from "./en-US.js"

export { molecules_blogCard_read } from "./en-US.js"

export { molecules_countdownTimer_days } from "./en-US.js"

export { molecules_countdownTimer_hours } from "./en-US.js"

export { molecules_countdownTimer_minutes } from "./en-US.js"

export { molecules_countdownTimer_seconds } from "./en-US.js"

export { molecules_filterBlock_topic } from "./en-US.js"

export { molecules_greenhouseDepartment_openRoles } from "./en-US.js"

export { molecules_greenhouseJob_save } from "./en-US.js"

export { molecules_greenhouseJob_saved } from "./en-US.js"

export { molecules_pagination_next } from "./en-US.js"

export { molecules_pagination_previous } from "./en-US.js"

export { molecules_relatedCard_openInANewTab } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `Buscar por tema o palabra clave`


export { molecules_subcategoryCard_articleSingular } from "./en-US.js"

export { molecules_subcategoryCard_articlesPlural } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_d } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_h } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_m } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_now } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_day } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_days } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hour } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hours } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minute } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minutes } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartIn } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartsNow } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_href = () => `/auth/logout`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `Cerrar sesión en Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label = () => `Ver mis credenciales en Accredible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_href = () => `https://v2.accounts.accredible.com/retrieve-credentials`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_label = () => `Ver mis credenciales`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `Mis recursos de Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_href = () => `/auth/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `Iniciar sesión en Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `Ponte en contacto con nosotros`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `Cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `Iniciar sesión`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = () => `https://www.klaviyo.com/support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = () => `Asistencia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `Buscar`


export { organisms_anchorLinks_backToTop } from "./en-US.js"

export { organisms_articleTableContents_overview } from "./en-US.js"

export { organisms_articleTableContents_tableContents } from "./en-US.js"

export { organisms_bfcmHero_eyebrow } from "./en-US.js"

export { organisms_bfcmHero_headline } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_iAm } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_iWantTo } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_thisBfcm } from "./en-US.js"

export { organisms_blogArticleHero_featureImageAltText } from "./en-US.js"

export { organisms_blogCards_viewAll } from "./en-US.js"

export { organisms_blogCards_viewCategory } from "./en-US.js"

export { organisms_blogLogoTag_tagline } from "./en-US.js"

export { organisms_blogLogoTag_title } from "./en-US.js"

export { organisms_blogSearchHero_customSearchHeadline } from "./en-US.js"

export { organisms_blogSearchHero_placeholder } from "./en-US.js"

export { organisms_countdownHero_days } from "./en-US.js"

export { organisms_countdownHero_hours } from "./en-US.js"

export { organisms_countdownHero_minutes } from "./en-US.js"

export { organisms_countdownHero_seconds } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_announcement } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productLaunch } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productPromotion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productUpdate } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_storewideSale } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_examplePrompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_loading } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_submit } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `Integra tu tienda y empieza a enviar mensajes con Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Primeros pasos con Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `Sienta las bases para enviar SMS correctamente.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/en-us/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `Cómo configurar la opción de SMS en Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `Crea y envía tu primera campaña de correo electrónico.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/en-us/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `Cómo crear y enviar una campaña de correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `Usa formularios para interactuar con tus suscriptores y recopilar más información sobre ellos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/en-us/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `Primeros pasos con los formularios de registro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `Crea flujos completos a gran escala usando lenguaje natural.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/en-us/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `Cómo usar Flows AI para crear un flujo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `Recopila comentarios de los clientes para conseguir más conversiones.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/en-us/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `Primeros pasos con las reseñas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `Cargar más`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Copyright © ${params.year} Klaviyo. Todos los derechos reservados.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `Tu configuración de privacidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `Solicitud de acceso a la cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/en-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `Solicitud de acceso a la cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `Asegúrate de que tu dirección de correo electrónico tenga una sola @, seguida de un dominio válido (nombre@ejemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `Ingresa un correo electrónico válido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_na_required = () => `Campo obligatorio: responde “NA” si no es aplicable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `Obligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `Asegúrate de que el sitio web de tu empresa incluya un dominio válido (https://ejemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `Cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `Ingresa el nombre de tu cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ Añadir destinatario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `Destinatarios adicionales (opcional)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `Ingresa una dirección de correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `Dirección de correo electrónico de la cuenta de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `Ingresa una dirección de correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `¿Con qué necesitas ayuda?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `Describe el problema`


export { organisms_forms_accountAccessForm_form_issueType_2_step_authentication } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `Cuenta inhabilitada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `Olvidé mi contraseña`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `Consulta sobre facturas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support = () => `Asistencia para la autenticación multifactor`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `Actualizar el propietario de la cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `Configurar un nuevo dispositivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_setting_up_new_device = () => `Configurar un nuevo dispositivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `Problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `Selecciona un problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name = () => `Nombre de la última campaña o flujo creados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder = () => `Ingresa el nombre de la campaña o el flujo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url = () => `Crea una nueva página en el sitio web de tu empresa con el título “Prueba de Klaviyo” y añade su URL aquí.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder = () => `Ingresa el URL del sitio web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info = () => `Por motivos de seguridad, responde a las siguientes preguntas lo mejor que puedas para verificar tu identidad. Si tienes dudas, escribe “NA”.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_info = () => `Usa este formulario solo para problemas con la autenticación multifactor; por ejemplo, si ya no puedes acceder al dispositivo de autenticación. Este formulario requiere datos personales para la autenticación manual. Si tienes problemas que no están relacionados con la autenticación multifactor, selecciona otra opción.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date = () => `Fecha estimada del último inicio de sesión`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder = () => `Ingresa la fecha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address = () => `Dirección postal de la organización registrada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder = () => `Ingresa una dirección`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails = () => `Nombres o direcciones de correo electrónico de otros usuarios de la cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder = () => `Ingresa los nombres o las direcciones de correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names = () => `Nombres o direcciones de correo electrónico de 5 perfiles de tu cuenta que tengan al menos 1 mes de antigüedad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder = () => `Ingresa los nombres o las direcciones de correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason = () => `Selecciona un motivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_lost_access_authenticator_app = () => `Ya no tengo acceso a la aplicación de autenticador`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_device = () => `Nuevo dispositivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_phone_number = () => `Nuevo número de teléfono`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_sms_code = () => `No recibí el código por SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice = () => `¿Cuál fue el importe de tu última factura de Klaviyo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder = () => `Ingresa el importe de la factura`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `Nombre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `Ingresa tu nombre completo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `Enviar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `URL del sitio web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `Ingresa un URL de sitio web`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `¿Tienes problemas para acceder a tu cuenta?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `Envíale tu información a nuestro equipo de asistencia y se pondrán en contacto contigo muy pronto.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `Ir a Inicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `Se envió tu solicitud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `Nuestro equipo de asistencia se pondrá en contacto contigo cuanto antes. Se enviará una respuesta a los correos electrónicos que proporcionaste.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `Todos los campos son obligatorios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Obtén una presentación gratuita para descubrir las posibilidades que ofrece la plataforma de datos de Klaviyo, la información basada en IA, los SMS y correos electrónicos personalizados, entre otras funciones. `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `Obtener una demostración`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `Enviando…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `Háblanos de tu marca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `Háblanos de tu marca`


export { organisms_forms_demo_recaptcha_privacy } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `Explorar todas las funciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `Ver recursos de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `Todo listo.`


export { organisms_forms_errors_generic } from "./en-US.js"

export { organisms_forms_errors_network } from "./en-US.js"

export { organisms_forms_errors_rateLimit } from "./en-US.js"

export { organisms_forms_errors_recaptcha } from "./en-US.js"

export { organisms_forms_fields_agency_label } from "./en-US.js"

export { organisms_forms_fields_company_errors_required } from "./en-US.js"

export { organisms_forms_fields_company_label } from "./en-US.js"

export { organisms_forms_fields_company_placeholder } from "./en-US.js"

export { organisms_forms_fields_company_size_errors_required } from "./en-US.js"

export { organisms_forms_fields_company_size_label } from "./en-US.js"

export { organisms_forms_fields_company_size_options_fiveHundred } from "./en-US.js"

export { organisms_forms_fields_company_size_options_one } from "./en-US.js"

export { organisms_forms_fields_company_size_options_oneHundred } from "./en-US.js"

export { organisms_forms_fields_company_size_options_oneMillion } from "./en-US.js"

export { organisms_forms_fields_company_size_options_three } from "./en-US.js"

export { organisms_forms_fields_company_size_options_twentyFive } from "./en-US.js"

export { organisms_forms_fields_company_size_options_zero } from "./en-US.js"

export { organisms_forms_fields_company_size_placeholder } from "./en-US.js"

export { organisms_forms_fields_company_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_company_website_errors_url } from "./en-US.js"

export { organisms_forms_fields_company_website_label } from "./en-US.js"

export { organisms_forms_fields_demo_requested_label } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_errors_required } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_label } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_BigCommerce } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Commercetools } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Magento } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Nuvemshop } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_OpenCart } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_PrestaShop } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Salesforce } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Shopify } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_ShopifyPlus } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Shopware } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_SquareOnline } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Wix } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_WooCommerce } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_custom } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_doesNotApply } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_other } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_placeholder } from "./en-US.js"

export { organisms_forms_fields_email_errors_email } from "./en-US.js"

export { organisms_forms_fields_email_errors_required } from "./en-US.js"

export { organisms_forms_fields_email_label } from "./en-US.js"

export { organisms_forms_fields_email_placeholder } from "./en-US.js"

export { organisms_forms_fields_field_15_errors_required } from "./en-US.js"

export { organisms_forms_fields_field_15_label } from "./en-US.js"

export { organisms_forms_fields_field_15_options_five } from "./en-US.js"

export { organisms_forms_fields_field_15_options_fourHundred } from "./en-US.js"

export { organisms_forms_fields_field_15_options_twenty } from "./en-US.js"

export { organisms_forms_fields_field_15_options_underFive } from "./en-US.js"

export { organisms_forms_fields_field_15_placeholder } from "./en-US.js"

export { organisms_forms_fields_field_16_errors_required } from "./en-US.js"

export { organisms_forms_fields_field_16_label } from "./en-US.js"

export { organisms_forms_fields_field_16_options_clientsBusiness } from "./en-US.js"

export { organisms_forms_fields_field_16_options_ownBusiness } from "./en-US.js"

export { organisms_forms_fields_field_16_placeholder } from "./en-US.js"

export { organisms_forms_fields_field_17_errors_required } from "./en-US.js"

export { organisms_forms_fields_field_17_label } from "./en-US.js"

export { organisms_forms_fields_field_17_options_other } from "./en-US.js"

export { organisms_forms_fields_field_17_options_retailGoods } from "./en-US.js"

export { organisms_forms_fields_field_17_options_retailServices } from "./en-US.js"

export { organisms_forms_fields_field_17_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_errors_required } from "./en-US.js"

export { organisms_forms_fields_full_name_errors_required } from "./en-US.js"

export { organisms_forms_fields_full_name_label } from "./en-US.js"

export { organisms_forms_fields_full_name_placeholder } from "./en-US.js"

export { organisms_forms_fields_general_errors_required } from "./en-US.js"

export { organisms_forms_fields_lastname_errors_required } from "./en-US.js"

export { organisms_forms_fields_newsletter_label } from "./en-US.js"

export { organisms_forms_fields_password_errors_common } from "./en-US.js"

export { organisms_forms_fields_password_errors_max } from "./en-US.js"

export { organisms_forms_fields_password_errors_min } from "./en-US.js"

export { organisms_forms_fields_password_errors_required } from "./en-US.js"

export { organisms_forms_fields_password_label } from "./en-US.js"

export { organisms_forms_fields_password_placeholder } from "./en-US.js"

export { organisms_forms_fields_phone_errors_matches } from "./en-US.js"

export { organisms_forms_fields_phone_errors_max } from "./en-US.js"

export { organisms_forms_fields_phone_errors_required } from "./en-US.js"

export { organisms_forms_fields_phone_label } from "./en-US.js"

export { organisms_forms_fields_phone_placeholder } from "./en-US.js"

export { organisms_forms_fields_product_interest_errors_required } from "./en-US.js"

export { organisms_forms_fields_product_interest_label } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_cdp } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_email } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_mobile_push } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_reviews } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_sms } from "./en-US.js"

export { organisms_forms_fields_product_interest_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_url } from "./en-US.js"

export { organisms_forms_legal_acknowledgement } from "./en-US.js"

export { organisms_forms_legal_and } from "./en-US.js"

export { organisms_forms_legal_privacyPolicy_href } from "./en-US.js"

export { organisms_forms_legal_privacyPolicy_label } from "./en-US.js"

export { organisms_forms_legal_termsOfService } from "./en-US.js"

export { organisms_forms_legal_termsOfService_href } from "./en-US.js"

export { organisms_forms_signup_body } from "./en-US.js"

export { organisms_forms_signup_button } from "./en-US.js"

export { organisms_forms_signup_buttonSubmitting } from "./en-US.js"

export { organisms_forms_signup_headline } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `Ir a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `Todas las ubicaciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `Buscar ofertas de empleo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `Todos los sistemas funcionan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `Servicio del sistema degradado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `Interrupción grave del sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `Interrupción menor del servicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `Interrupción menor del sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `Interrupción parcial del sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `Servicio parcialmente degradado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `Sistema parcialmente degradado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `Servicio en mantenimiento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `Cerrar ventana modal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `Visita la comunidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `Comunidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_icon_iconName = () => `Comunidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `Conecta con colegas, socios y expertos de Klaviyo para inspirarte, compartir ideas y resolver todas tus dudas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `Regístrate ahora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `Capacitación en vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_icon_iconName = () => `Calendario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Únete a una sesión en tiempo real con expertos de Klaviyo para conocer las mejores prácticas, cómo configurar funciones clave y mucho más.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `Iniciar sesión`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `Asistencia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_icon_iconName = () => `Asistencia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `Accede a la asistencia a través de tu cuenta.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `Asistencia virtual/por chat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `La disponibilidad varía según la ubicación y el tipo de plan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `Asistencia por correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(prueba gratuita y cuentas de pago)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `Disponible 24/7`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewAllButton_text = () => `Ver todas las categorías`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewLessButton_text = () => `Ver menos categorías`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `Obtener una demostración`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Ir a la página de inicio de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Ir a la página de recursos <strong>El potenciador de Klaviyo</strong>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Logotipo de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Novedades de productos de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `Leer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `Ver todos`


export { organisms_post_filter_ResourceCategory } from "./en-US.js"

export { organisms_post_filter_ResourceCollection } from "./en-US.js"

export { organisms_post_filter_ResourceStage } from "./en-US.js"

export { organisms_post_filter_ResourceTopic } from "./en-US.js"

export { organisms_post_filter_read_more } from "./en-US.js"

export { organisms_post_filter_search } from "./en-US.js"

export { organisms_pricing_calculator_carrierFeeDisclaimer } from "./en-US.js"

export { organisms_pricing_calculator_carrierFeeDisclaimerEnd } from "./en-US.js"

export { organisms_pricing_calculator_credit } from "./en-US.js"

export { organisms_pricing_calculator_credits } from "./en-US.js"

export { organisms_pricing_calculator_destination } from "./en-US.js"

export { organisms_pricing_calculator_headline } from "./en-US.js"

export { organisms_pricing_calculator_locales_AT } from "./en-US.js"

export { organisms_pricing_calculator_locales_AU } from "./en-US.js"

export { organisms_pricing_calculator_locales_BE } from "./en-US.js"

export { organisms_pricing_calculator_locales_CA } from "./en-US.js"

export { organisms_pricing_calculator_locales_CH } from "./en-US.js"

export { organisms_pricing_calculator_locales_DE } from "./en-US.js"

export { organisms_pricing_calculator_locales_DK } from "./en-US.js"

export { organisms_pricing_calculator_locales_ES } from "./en-US.js"

export { organisms_pricing_calculator_locales_FI } from "./en-US.js"

export { organisms_pricing_calculator_locales_FR } from "./en-US.js"

export { organisms_pricing_calculator_locales_GB } from "./en-US.js"

export { organisms_pricing_calculator_locales_HU } from "./en-US.js"

export { organisms_pricing_calculator_locales_IE } from "./en-US.js"

export { organisms_pricing_calculator_locales_IT } from "./en-US.js"

export { organisms_pricing_calculator_locales_NL } from "./en-US.js"

export { organisms_pricing_calculator_locales_NO } from "./en-US.js"

export { organisms_pricing_calculator_locales_NZ } from "./en-US.js"

export { organisms_pricing_calculator_locales_PL } from "./en-US.js"

export { organisms_pricing_calculator_locales_PT } from "./en-US.js"

export { organisms_pricing_calculator_locales_SE } from "./en-US.js"

export { organisms_pricing_calculator_locales_US } from "./en-US.js"

export { organisms_pricing_calculator_maxSends } from "./en-US.js"

export { organisms_pricing_calculator_mms } from "./en-US.js"

export { organisms_pricing_calculator_mms_limit } from "./en-US.js"

export { organisms_pricing_calculator_mms_not_available } from "./en-US.js"

export { organisms_pricing_calculator_not_available } from "./en-US.js"

export { organisms_pricing_calculator_pricePer } from "./en-US.js"

export { organisms_pricing_calculator_pricePerSend } from "./en-US.js"

export { organisms_pricing_calculator_sendTo } from "./en-US.js"

export { organisms_pricing_calculator_service_type } from "./en-US.js"

export { organisms_pricing_calculator_sms } from "./en-US.js"

export { organisms_pricing_calculator_sms_limit } from "./en-US.js"

export { organisms_pricing_contactLimitExceeded } from "./en-US.js"

export { organisms_pricing_contactSales } from "./en-US.js"

export { organisms_pricing_contacts } from "./en-US.js"

export { organisms_pricing_contacts_slider_headline } from "./en-US.js"

export { organisms_pricing_contacts_slider_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_credits_slider_headline } from "./en-US.js"

export { organisms_pricing_credits_slider_subText } from "./en-US.js"

export { organisms_pricing_credits_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_csm } from "./en-US.js"

export { organisms_pricing_emailAndChatSupport } from "./en-US.js"

export { organisms_pricing_eyebrow } from "./en-US.js"

export { organisms_pricing_freeCredits } from "./en-US.js"

export { organisms_pricing_freeSupport } from "./en-US.js"

export { organisms_pricing_getADemo } from "./en-US.js"

export { organisms_pricing_headline } from "./en-US.js"

export { organisms_pricing_includesFees } from "./en-US.js"

export { organisms_pricing_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_maxContacts_headline } from "./en-US.js"

export { organisms_pricing_maxContacts_richTextBody } from "./en-US.js"

export { organisms_pricing_mobilePush } from "./en-US.js"

export { organisms_pricing_modalContent_copyText1 } from "./en-US.js"

export { organisms_pricing_modalContent_copyText2 } from "./en-US.js"

export { organisms_pricing_modalContent_headline } from "./en-US.js"

export { organisms_pricing_month } from "./en-US.js"

export { organisms_pricing_monthlyEmailSends } from "./en-US.js"

export { organisms_pricing_monthlySmsMmsCredits } from "./en-US.js"

export { organisms_pricing_onboarding } from "./en-US.js"

export { organisms_pricing_opensAModal } from "./en-US.js"

export { organisms_pricing_per_month } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextTooltiptInfo } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_collapsible_button } from "./en-US.js"

export { organisms_pricing_plans_emailAndSms_calloutText } from "./en-US.js"

export { organisms_pricing_plans_emailAndSms_copy } from "./en-US.js"

export { organisms_pricing_plans_emailAndSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_creditsSubText } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_recommended } from "./en-US.js"

export { organisms_pricing_plans_email_calloutText } from "./en-US.js"

export { organisms_pricing_plans_email_copy } from "./en-US.js"

export { organisms_pricing_plans_email_emails_label } from "./en-US.js"

export { organisms_pricing_plans_email_name } from "./en-US.js"

export { organisms_pricing_plans_email_per_month } from "./en-US.js"

export { organisms_pricing_plans_expandable_button } from "./en-US.js"

export { organisms_pricing_plans_free_calloutText } from "./en-US.js"

export { organisms_pricing_plans_free_copy } from "./en-US.js"

export { organisms_pricing_plans_free_name } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_bottom } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_top } from "./en-US.js"

export { organisms_pricing_plans_getStarted_text } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_headline } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_price_subText } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_subText } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_above250kContacts } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_below250Contacts } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subText } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_reviews_slider_subText } from "./en-US.js"

export { organisms_pricing_plans_reviews_subText } from "./en-US.js"

export { organisms_pricing_plusSign } from "./en-US.js"

export { organisms_pricing_rates_regionAUS_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionAUS_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionAUS_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionCanada_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionCanada_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionCanada_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionFrance_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionFrance_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionFrance_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionGermany_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionGermany_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionGermany_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionIreland_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionIreland_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionIreland_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionItaly_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionItaly_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionItaly_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionNZ_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionNZ_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionNZ_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionNetherlands_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionNetherlands_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionNetherlands_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionPortugal_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionPortugal_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionPortugal_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionUK_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionUK_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionUK_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionUSA_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionUSA_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionUSA_regionName } from "./en-US.js"

export { organisms_pricing_signUp } from "./en-US.js"

export { organisms_pricing_startingAt } from "./en-US.js"

export { organisms_pricing_supportToScale } from "./en-US.js"

export { organisms_scroll_social_proof_button } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_3 } from "./en-US.js"

export { organisms_scroll_social_proof_href } from "./en-US.js"

export { organisms_scroll_social_proof_quote_end } from "./en-US.js"

export { organisms_scroll_social_proof_quote_start } from "./en-US.js"

export { organisms_searchBar_placeholder_case_study } from "./en-US.js"

export { organisms_searchBar_placeholder_compare_page } from "./en-US.js"

export { organisms_searchBar_placeholder_marketing_resource } from "./en-US.js"

export { organisms_searchBar_placeholder_newsroom_article } from "./en-US.js"

export { organisms_searchBar_placeholder_page } from "./en-US.js"

export { organisms_searchBar_placeholder_partner_page } from "./en-US.js"

export { organisms_searchBar_placeholder_podcast_page } from "./en-US.js"

export { organisms_searchBar_placeholder_post } from "./en-US.js"

export { organisms_searchBar_placeholder_product_update } from "./en-US.js"

export { organisms_searchBar_placeholder_solutions_page } from "./en-US.js"

export { organisms_searchBar_placeholder_success_page } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_button } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_href } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_subhead } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_benchmarks } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_customer_hub } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_email_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_integrations } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_klaviyo_ai } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_mobile_push } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_profiles } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reporting } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reviews } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_segments } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_sms_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_27Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_43Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_consentedToReceiveSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_createWithAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_describeFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_dontLeaveItBehind } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_generateDraft } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_hasViewedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_klaviyoAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_smsABTest } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_viewAbandonedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_weLoveThatYouLoveThisDontLeaveItBehindClickToShop } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_whenSomeoneViewsAProductAndDoesNotBuySendAnSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_champions } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_championsFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionOverview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_eightPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_excellent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_exclusiveOffer } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fivePointTwoZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fortyThreeThousandSixHundredNineteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fourHundredFiftyTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersAdded } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersDropped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthOne } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_oneThousandFiveHundredThirteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_rfmGroupIsChampion } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_segmentGrowthReport } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_sevenPointFiveZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_threePercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_totalMembers } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_accessories } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_activity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToBag } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToCart } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_arrivingToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_chat } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_clothing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_color } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_coral } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_featherweightRunningShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_findAStore } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_forYou } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_help } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_horizonRibbedTrainingSet } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_l } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_maroon } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_membersFreeShippingOnOrdersFiftyPlus } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliams } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedTheWrongSizeShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_new } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_orders } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_phoneNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_pleaseHoldForAMomentWhileWeConnectYouWithAnAgent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_profile } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_recentlyViewed } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_saySomething } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_seanH } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_selectSize } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_shoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sky } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_thirtyFivePointNinetyNine } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_twoHundredTen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_welcomeMia } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xs } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xxl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_yesThatsMyOrderThanksForYourHelp } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_Enjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_customerActivity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_discountCode } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_email } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_inbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_name } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_openedEmailDiscount } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderDelivered } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderShipped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_placedOrderForTwoHundredSix } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_shopNow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_tenPercentOff } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_thanksForYourFeedbackEnjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_4 } from "./en-US.js"

export { organisms_tileList_viewAll } from "./en-US.js"

export { organisms_video_playVideo } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `Borrar todo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `Contraer todo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `Todas las actualizaciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `Cuenta y facturación`


export { organisms_whatsNew_refinements_advanced_kdp } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `Análisis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `Público`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `Beneficios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `Campañas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `Próximamente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `Capacidad de entrega y cumplimiento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `Correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `Flujos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `Disponibilidad general`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `Lanzamiento gradual`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `Integraciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `Disponibilidad limitada`


export { organisms_whatsNew_refinements_marketing_analytics } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `Notificaciones push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `Tipo de lanzamiento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `Reseñas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `Formularios de registro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `Tema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `Ver resumen trimestral`


export { pages_careers_searchJobs_breadcrumbs_home } from "./en-US.js"

export { pages_careers_searchJobs_breadcrumbs_searchJobs } from "./en-US.js"

export { pages_careers_searchJobs_form_applyFilters } from "./en-US.js"

export { pages_careers_searchJobs_form_clearFilters } from "./en-US.js"

export { pages_careers_searchJobs_form_country } from "./en-US.js"

export { pages_careers_searchJobs_form_keywords } from "./en-US.js"

export { pages_careers_searchJobs_form_keywordsPlaceholder } from "./en-US.js"

export { pages_careers_searchJobs_form_legend } from "./en-US.js"

export { pages_careers_searchJobs_form_location } from "./en-US.js"

export { pages_careers_searchJobs_form_noResults } from "./en-US.js"

export { pages_careers_searchJobs_form_noResultsReset } from "./en-US.js"

export { pages_careers_searchJobs_form_searchResults } from "./en-US.js"

export { pages_careers_searchJobs_form_team } from "./en-US.js"

export { pages_careers_searchJobs_headline } from "./en-US.js"

export { pages_careers_searchJobs_pageTitle } from "./en-US.js"

export { pages_careers_searchJobs_recentJobs } from "./en-US.js"

export { pages_careers_searchJobs_savedJobs } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `¿No es lo que buscabas? Ve a la <a href="/email-marketing">página de correo electrónico</a>, a la <a href="/sms-marketing">página de SMS</a> o vuelve a la <a href="/">página de inicio</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `Ir a Inicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `No se encontró la página`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `Se pronuncia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `horas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `minutos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `hora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `minuto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `Pregunta respondida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `Todos los recursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `Borrar todo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `Contraer todo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `Comunidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `Desarrolladores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `Centro de ayuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `Recursos de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `Recurso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `Buscar todos los recursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `Revisa la ortografía o prueba otra búsqueda.`


/**
 * @param {{ query: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `No se encontraron resultados para "${params.query}".`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `Buscar por tema o palabra clave`


export { pages_search_refinementsAccordionLabel_academy_duration } from "./en-US.js"

export { pages_search_refinementsAccordionLabel_academy_language } from "./en-US.js"

export { pages_search_refinementsAccordionLabel_academy_location } from "./en-US.js"

export { pages_search_refinementsAccordionLabel_academy_type } from "./en-US.js"

export { pages_search_refinements_academy_language_english } from "./en-US.js"

export { pages_search_refinements_academy_language_french } from "./en-US.js"

export { pages_search_refinements_academy_language_spanish } from "./en-US.js"

export { pages_search_refinements_academy_location_apac } from "./en-US.js"

export { pages_search_refinements_academy_location_emea } from "./en-US.js"

export { pages_search_refinements_academy_location_nam } from "./en-US.js"

export { pages_search_refinements_academy_type_liveTraining } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_category = () => `Categoría`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType = () => `Tipo de publicación`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_bfcm_page = () => `Black Friday y Cyber Monday (BFCM)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_case_study = () => `Caso de estudio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_compare_page = () => `Comparaciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_demos_page = () => `Demostraciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_industry_page = () => `Sectores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_marketing_resource = () => `Recurso de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_newsroom_article = () => `Noticias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_page = () => `Páginas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_partner_page = () => `Socios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_podcast_page = () => `Pódcast`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_post = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_product_update = () => `Actualización de producto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_products_page = () => `Productos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_quarterly_page = () => `Lanzamiento trimestral`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_solutions_page = () => `Soluciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_success_page = () => `Éxito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_tools_page = () => `Herramientas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `Cuenta y facturación`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `Análisis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `Público`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `Campañas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `Plataforma de datos de clientes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `Capacidad de entrega y cumplimiento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `Correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `Flujos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `Integraciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `Notificaciones push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `Reseñas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `Formularios de registro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `Resultados de búsqueda principales`


/**
 * @param {{ y: NonNullable<unknown>, x: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `Mostrando ${params.y} de ${params.x}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `Búsquedas sugeridas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Primeros pasos con Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `Primeros pasos con los SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Primeros pasos con la plataforma de datos de clientes de Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `Primeros pasos con los formularios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `Black Friday Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Crear un calendario de contenido en Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `Ver`


/**
 * @param {{ index: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `Ver los ${params.index} resultados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `Ver más`


export { pages_sitemap_header } from "./en-US.js"

export { pages_sitemap_title } from "./en-US.js"

export { roiCalculator_form_brandText } from "./en-US.js"

export { roiCalculator_form_channelsUsed } from "./en-US.js"

export { roiCalculator_form_fieldsRequired } from "./en-US.js"

export { roiCalculator_form_inputActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputEnterAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputEnterCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputEnterOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputPrefix } from "./en-US.js"

export { roiCalculator_form_inputSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_roiButton } from "./en-US.js"

export { roiCalculator_form_toggleEmail } from "./en-US.js"

export { roiCalculator_form_toggleEmailAndSms } from "./en-US.js"

export { roiCalculator_results_automatedFlows } from "./en-US.js"

export { roiCalculator_results_campaigns } from "./en-US.js"

export { roiCalculator_results_freeTier } from "./en-US.js"

export { roiCalculator_results_getStartedButton } from "./en-US.js"

export { roiCalculator_results_headlineText } from "./en-US.js"

export { roiCalculator_results_invalidRoi } from "./en-US.js"

export { roiCalculator_results_newSubscribers } from "./en-US.js"

export { roiCalculator_results_revenuePerYear } from "./en-US.js"

export { roiCalculator_results_signupText } from "./en-US.js"

export { roiCalculator_results_subHeadlineText } from "./en-US.js"

export { roiCalculator_results_talkToSales } from "./en-US.js"

export { templates_archive_author_openInANewTab } from "./en-US.js"

export { templates_archive_author_postsByThisAuthor } from "./en-US.js"

export { templates_archive_category_articles } from "./en-US.js"

export { templates_archive_category_featured } from "./en-US.js"

export { templates_caseStudy_customer } from "./en-US.js"

export { templates_caseStudy_industry } from "./en-US.js"

export { templates_caseStudy_platform } from "./en-US.js"

export { pages_b2ccrm_hero_video_id } from "./en-US.js"

export { pages_b2ccrm_introduction_subtext } from "./en-US.js"

export { pages_b2ccrm_marketing_p1 } from "./en-US.js"

export { pages_b2ccrm_marketing_p2 } from "./en-US.js"

export { pages_b2ccrm_marketing_p3 } from "./en-US.js"

export { pages_b2ccrm_service_p1 } from "./en-US.js"

export { pages_b2ccrm_service_rive_message_2 } from "./en-US.js"

export { pages_b2ccrm_service_rive_phone_number } from "./en-US.js"

export { pages_b2ccrm_analytics_rive_revenue_number_sign } from "./en-US.js"

export { pages_b2ccrm_platform_rive_placed_order } from "./en-US.js"

export { pages_b2ccrm_service_rive_dash_item_cost } from "./en-US.js"

export { pages_b2ccrm_service_rive_item_price } from "./en-US.js"

export { pages_b2ccrm_service_rive_shipping } from "./en-US.js"

export { roiCalculator_results_getStartedButton_href } from "./en-US.js"

export { roiCalculator_results_talkToSales_href } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Apply } from "./en-US.js"

export { AppMarketplace_Browse_Filters_BuiltBy } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Category } from "./en-US.js"

export { AppMarketplace_Browse_Filters_CollapseAll } from "./en-US.js"

export { AppMarketplace_Browse_Filters_FilterItemWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabel } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabelWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_ResetAll } from "./en-US.js"

export { AppMarketplace_Browse_Heading } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Plural } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Singular } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body_Alt } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Heading } from "./en-US.js"

export { AppMarketplace_Details_Articles_CaseStudyImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_NavigationIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_UserGuideIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Info_ApplicationLogo_Alt } from "./en-US.js"

export { AppMarketplace_Details_InstallButton_UninstallableWarningImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Page_Title } from "./en-US.js"

export { AppMarketplace_Discovery_App_BuiltBy } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_ActionRequired } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_GenericPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_Installed } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_UserPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Card_BannerImage_Alt } from "./en-US.js"

export { AppMarketplace_Discovery_Card_Icon_Alt } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllApps } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllAppsAriaLabel } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL1 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2Highlight } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericMobileHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_LogInAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_SignUpAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserGreeting } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserHeading } from "./en-US.js"

export { AppMarketplace_Drawer_AccountManagement } from "./en-US.js"

export { AppMarketplace_Drawer_ApplicationManagement } from "./en-US.js"

export { AppMarketplace_Drawer_Categories } from "./en-US.js"

export { AppMarketplace_Header_CategoriesButton_Label } from "./en-US.js"

export { AppMarketplace_Header_LoginButton_Label } from "./en-US.js"

export { AppMarketplace_Header_Logo_Alt } from "./en-US.js"

export { AppMarketplace_Header_MenuIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_Placeholder } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_SearchIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_ApplicationsSection_Label } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_CategoriesSection_Label } from "./en-US.js"

export { AppMarketplace_Preview_Site_Title } from "./en-US.js"

export { AppMarketplace_Site_Description } from "./en-US.js"

export { AppMarketplace_Site_Title } from "./en-US.js"

export { academy_lesson_bottom_nav_catalog_label } from "./en-US.js"

export { academy_lesson_bottom_nav_collection_label } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { academy_search_href } from "./en-US.js"

export { app_marketplace_details_built_by } from "./en-US.js"

export { app_marketplace_details_carousel_close } from "./en-US.js"

export { app_marketplace_details_carousel_image_alt } from "./en-US.js"

export { app_marketplace_details_carousel_next_image } from "./en-US.js"

export { app_marketplace_details_carousel_previous_image } from "./en-US.js"

export { app_marketplace_details_case_study } from "./en-US.js"

export { app_marketplace_details_category } from "./en-US.js"

export { app_marketplace_details_cover_image } from "./en-US.js"

export { app_marketplace_details_developer } from "./en-US.js"

export { app_marketplace_details_features } from "./en-US.js"

export { app_marketplace_details_guide } from "./en-US.js"

export { app_marketplace_details_install } from "./en-US.js"

export { app_marketplace_details_install_installs } from "./en-US.js"

export { app_marketplace_details_languages } from "./en-US.js"

export { app_marketplace_details_marketing_video } from "./en-US.js"

export { app_marketplace_details_overview } from "./en-US.js"

export { app_marketplace_details_pricing } from "./en-US.js"

export { app_marketplace_details_pricing_free } from "./en-US.js"

export { app_marketplace_details_pricing_learn_more } from "./en-US.js"

export { app_marketplace_details_similar_apps } from "./en-US.js"

export { app_marketplace_details_support } from "./en-US.js"

export { app_marketplace_details_support_help } from "./en-US.js"

export { app_marketplace_details_support_privacy } from "./en-US.js"

export { app_marketplace_details_support_website } from "./en-US.js"

export { app_marketplace_details_user_guide } from "./en-US.js"

export { app_marketplace_gallery_thumbnail } from "./en-US.js"

export { app_marketplace_gallery_thumbnail_alt } from "./en-US.js"

export { app_marketplace_install_alert_learn_more } from "./en-US.js"

export { app_marketplace_install_button } from "./en-US.js"

export { app_marketplace_install_status_invalid_permissions } from "./en-US.js"

export { app_marketplace_install_status_unhealthy } from "./en-US.js"

export { app_marketplace_install_status_uninstallable } from "./en-US.js"

export { app_marketplace_installed_button } from "./en-US.js"

export { app_marketplace_manage_button } from "./en-US.js"

export { app_marketplace_notFound_button_text } from "./en-US.js"

export { app_marketplace_preview_banner } from "./en-US.js"

export { developer_portal_get_started_card_one_description } from "./en-US.js"

export { developer_portal_get_started_card_one_title } from "./en-US.js"

export { developer_portal_get_started_card_three_description } from "./en-US.js"

export { developer_portal_get_started_card_three_title } from "./en-US.js"

export { developer_portal_get_started_card_two_description } from "./en-US.js"

export { developer_portal_get_started_card_two_title } from "./en-US.js"

export { developer_portal_get_started_header } from "./en-US.js"

export { developer_portal_need_more_help_card_one_description } from "./en-US.js"

export { developer_portal_need_more_help_card_one_title } from "./en-US.js"

export { developer_portal_need_more_help_card_two_description } from "./en-US.js"

export { developer_portal_need_more_help_card_two_title } from "./en-US.js"

export { developer_portal_need_more_help_header } from "./en-US.js"

export { developer_portal_use_cases_cta } from "./en-US.js"

export { developer_portal_use_cases_header } from "./en-US.js"

export { developer_portal_use_cases_tab_one_author } from "./en-US.js"

export { developer_portal_use_cases_tab_one_description } from "./en-US.js"

export { developer_portal_use_cases_tab_one_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_one_title } from "./en-US.js"

export { developer_portal_use_cases_tab_three_author } from "./en-US.js"

export { developer_portal_use_cases_tab_three_description } from "./en-US.js"

export { developer_portal_use_cases_tab_three_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_three_title } from "./en-US.js"

export { developer_portal_use_cases_tab_two_author } from "./en-US.js"

export { developer_portal_use_cases_tab_two_description } from "./en-US.js"

export { developer_portal_use_cases_tab_two_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_two_title } from "./en-US.js"

export { molecules_blogCard_related_content } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_href = () => `/en-us/profile`


export { organisms_forms_fields_company_website_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_placeholder } from "./en-US.js"

export { organisms_forms_fields_form_opt_in_label } from "./en-US.js"

export { organisms_forms_fields_lastname_placeholder } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_errors_required } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_website_placeholder } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_openInNewTab = () => `falso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_openInNewTab = () => `falso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_openInNewTab = () => `falso`


/**
 * @param {{ accessSupport: NonNullable<unknown>, emailSupport: NonNullable<unknown>, emailSupportAccountTypes: NonNullable<unknown>, emailSupportAvailability: NonNullable<unknown>, chatVirtualAssistance: NonNullable<unknown>, chatVirtualAssistanceAvailability: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_template = (params) => `<p>${params.accessSupport}</p>
    <p class="supportMethod">
      <strong class="methodName">${params.emailSupport}</strong> <span class="methodDetail"><em>${params.emailSupportAccountTypes}</em></span>
      ${params.emailSupportAvailability}
    </p>
    <p class="supportMethod">
      <strong class="methodName">${params.chatVirtualAssistance}<br/></strong>
      ${params.chatVirtualAssistanceAvailability}<br/>
    </p>`


export { pages_b2ccrm_analytics_cta } from "./en-US.js"

export { pages_b2ccrm_analytics_eyebrow } from "./en-US.js"

export { pages_b2ccrm_analytics_headline } from "./en-US.js"

export { pages_b2ccrm_analytics_logo } from "./en-US.js"

export { pages_b2ccrm_analytics_p1 } from "./en-US.js"

export { pages_b2ccrm_analytics_p2 } from "./en-US.js"

export { pages_b2ccrm_analytics_p3 } from "./en-US.js"

export { pages_b2ccrm_analytics_quote } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_title } from "./en-US.js"

export { pages_b2ccrm_description } from "./en-US.js"

export { pages_b2ccrm_hero_content_cta } from "./en-US.js"

export { pages_b2ccrm_hero_content_finally } from "./en-US.js"

export { pages_b2ccrm_hero_content_title } from "./en-US.js"

export { pages_b2ccrm_hero_rip_headline } from "./en-US.js"

export { pages_b2ccrm_hero_rip_instructions } from "./en-US.js"

export { pages_b2ccrm_introduction_eyebrow } from "./en-US.js"

export { pages_b2ccrm_introduction_headline } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_tag } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4_copy } from "./en-US.js"

export { pages_b2ccrm_marketing_cta } from "./en-US.js"

export { pages_b2ccrm_marketing_eyebrow } from "./en-US.js"

export { pages_b2ccrm_marketing_headline } from "./en-US.js"

export { pages_b2ccrm_marketing_logo } from "./en-US.js"

export { pages_b2ccrm_marketing_quote } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_title } from "./en-US.js"

export { pages_b2ccrm_nav_analytics } from "./en-US.js"

export { pages_b2ccrm_nav_marketing } from "./en-US.js"

export { pages_b2ccrm_nav_platform } from "./en-US.js"

export { pages_b2ccrm_nav_quiz } from "./en-US.js"

export { pages_b2ccrm_nav_service } from "./en-US.js"

export { pages_b2ccrm_nav_the_b2c_crm } from "./en-US.js"

export { pages_b2ccrm_nav_watch_demo } from "./en-US.js"

export { pages_b2ccrm_platform_cta } from "./en-US.js"

export { pages_b2ccrm_platform_eyebrow } from "./en-US.js"

export { pages_b2ccrm_platform_headline } from "./en-US.js"

export { pages_b2ccrm_platform_logo } from "./en-US.js"

export { pages_b2ccrm_platform_p1 } from "./en-US.js"

export { pages_b2ccrm_platform_p2 } from "./en-US.js"

export { pages_b2ccrm_platform_p3 } from "./en-US.js"

export { pages_b2ccrm_platform_stat } from "./en-US.js"

export { pages_b2ccrm_platform_stat_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_cta } from "./en-US.js"

export { pages_b2ccrm_quiz_eyebrow } from "./en-US.js"

export { pages_b2ccrm_quiz_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_subtext } from "./en-US.js"

export { pages_b2ccrm_service_cta } from "./en-US.js"

export { pages_b2ccrm_service_eyebrow } from "./en-US.js"

export { pages_b2ccrm_service_headline } from "./en-US.js"

export { pages_b2ccrm_service_logo } from "./en-US.js"

export { pages_b2ccrm_service_p2 } from "./en-US.js"

export { pages_b2ccrm_service_p3 } from "./en-US.js"

export { pages_b2ccrm_service_quote } from "./en-US.js"

export { pages_b2ccrm_service_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_service_quote_title } from "./en-US.js"

export { pages_b2ccrm_title } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_cdp = () => `Plataforma de datos de clientes`


export { academy_courseStatus_registed } from "./en-US.js"

export { helpCenter_templates_search_results } from "./en-US.js"

export { organisms_forms_legal_agreeTermsLinkText } from "./en-US.js"

export { organisms_forms_legal_agreeToPartnerCodeOfConduct } from "./en-US.js"

export { organisms_forms_legal_agreeToTermsOfService } from "./en-US.js"

export { organisms_forms_legal_codeOfConduct_href } from "./en-US.js"

export { organisms_forms_legal_marketingCommunicationsConsent } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_headline } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_richTextBody } from "./en-US.js"

export { organisms_pricing_calculator_locales_BR } from "./en-US.js"